import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "@app/store";
import { useLazyGetProductsQuery } from "@modules/product";
import { setProducts } from "@modules/product/store/product.slice";
import { arrayMoveImmutable } from "array-move";
import { IProduct } from "@modules/product/types";
import { useUpdateProductOrderingMutation } from "@modules/product/api/product.api";

export const useProductOrderingLogic = () => {
  const dispatch = useAppDispatch();
  const productList = useAppSelector((state) => state.product.products)
  const [updateOrdering] = useUpdateProductOrderingMutation()
  const [getProducts] = useLazyGetProductsQuery()

  const handleGetRequest = async () => {
    try {
      const responseProducts = await getProducts({}).unwrap();

      dispatch(setProducts(responseProducts.products));
    } catch (error) {
      console.log(error);
    }
  };

  const onSortEnd = async (oldIndex: number, newIndex: number) => {
    const clone = JSON.parse(JSON.stringify(productList)) as IProduct[]

    const sortedList = arrayMoveImmutable(clone, oldIndex, newIndex)

    dispatch(setProducts(sortedList));
    await updateOrdering({ ids: sortedList.map((item) => item.id) })
  }

  useEffect(() => {
    handleGetRequest()
  }, [])

  return {
    productList,
    onSortEnd,
  }
}
